export default __webpack_public_path__ + "static/media/017-egg.4ae04a37.svg";